import React, { FC } from 'react';

import { FormSection, IncomeSectionHeading } from '../../styles';
import { DsaVariantType } from '../../types';
import { RadioGroup, RadioOption, ToolTip } from 'src/commons/components';
import { NPC_FUNNEL_DSA_ONE_KEY } from 'src/commons/constants';
import { getOptimizelyVariation } from 'src/commons/utilities/feature-flags';

interface ApplicationDSAProps {
  isDsaEnabled?: boolean;
  error?: any;
  onDsaSelected: (isDsa: boolean) => void;
}

export const ApplicationDSA: FC<ApplicationDSAProps> = ({
  isDsaEnabled = undefined,
  error = null,
  onDsaSelected,
}) => {
  const feature = getOptimizelyVariation(
    NPC_FUNNEL_DSA_ONE_KEY
  ).toLowerCase() as DsaVariantType;

  const isVariantA = feature === 'variant-a';
  const isVariantB = feature === 'variant-b';
  const isControl = !isVariantA && !isVariantB;

  if (isControl) return null;

  const headingText = isVariantA
    ? 'Are you currently enrolled in or considering a debt settlement program?'
    : 'Are you working with or considering working with a company to settle your debts?';

  const toolTipHeading = isVariantA
    ? 'What is a debt settlement program?'
    : undefined;
  const toolTipBody = isVariantA
    ? 'A debt settlement program is when you and a creditor agree to settle your debt for less than you owe. These are often negotiated for you by debt settlement  agencies, sometimes for a fee.'
    : 'A company that helps you manage debt typically negotiates with your creditor to settle the debt for less than you owe, sometimes for a fee.';

  return (
    <FormSection>
      <IncomeSectionHeading id="dsaSectionHeading">
        {headingText}
        <ToolTip
          id="dsa-tooltip"
          isGrayInfoIcon
          heading={toolTipHeading}
          body={toolTipBody}
        />
      </IncomeSectionHeading>

      <RadioGroup name="isDsaEnrolled" error={error}>
        <RadioOption
          label="No"
          value={false}
          selected={isDsaEnabled === false}
          error={error}
          onValueSelected={onDsaSelected}
        />
        <RadioOption
          label="Yes"
          value
          selected={isDsaEnabled === true}
          error={error}
          onValueSelected={onDsaSelected}
        />
      </RadioGroup>
    </FormSection>
  );
};
